import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1022KtoRenameStatus: 'idle',
    startProcess1022KtoRenameError: undefined as any,
    loadUserParamsProcess1022KtoRenameStatus: 'idle',
    loadUserParamsProcess1022KtoRenameError: undefined as any,

    process1022KtoRenameList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1022KtoRename = createAsyncThunk('process1022KtoRenameSlice/startProcess1022KtoRename', async ({ process1022KtoRename }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1022KtoRename/`,
        prepareData(process1022KtoRename),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1022KtoRenameStatus } = getState().process1022KtoRenameSlice
        return startProcess1022KtoRenameStatus !== 'pending'
    }
})

export const loadUserParamsProcess1022KtoRename = createAsyncThunk('process1022KtoRenameSlice/loadUserParamsProcess1022KtoRename', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1022KtoRename/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1022KtoRenameStatus } = getState().process1022KtoRenameSlice
        return loadUserParamsProcess1022KtoRenameStatus !== 'pending'
    }
})

const Process1022KtoRenameSlice = createSlice({
    name: 'process1022KtoRenameSlice',
    initialState,
    reducers: {
        resetstartProcess1022KtoRename: (state) => {
            state.job = undefined
            state.startProcess1022KtoRenameError = undefined
        },
        resetstartProcess1022KtoRenameError: (state) => {
            state.startProcess1022KtoRenameError = undefined
        },
        resetloadUserParamsProcess1022KtoRename: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1022KtoRenameError = undefined
        },
        resetloadUserParamsProcess1022KtoRenameError: (state) => {
            state.loadUserParamsProcess1022KtoRenameError = undefined
        },
        removeFromProcess1022KtoRenameListById: (state, action) => {
            state.process1022KtoRenameList = state.process1022KtoRenameList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1022KtoRenameListByIds: (state, action) => {
            state.process1022KtoRenameList = state.process1022KtoRenameList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1022KtoRenameList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1022KtoRenameStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1022KtoRenameList = []
            state.startProcess1022KtoRenameStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1022KtoRename.pending, (state) => {
            state.startProcess1022KtoRenameStatus = 'pending'
            state.startProcess1022KtoRenameError = undefined
        })
        builder.addCase(startProcess1022KtoRename.fulfilled, (state, action) => {
            state.startProcess1022KtoRenameStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1022KtoRename.rejected, (state, action) => {
            state.startProcess1022KtoRenameStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1022KtoRenameError = action.error.message
            } else {
                state.startProcess1022KtoRenameError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1022KtoRename.pending, (state) => {
            state.loadUserParamsProcess1022KtoRenameStatus = 'pending'
            state.loadUserParamsProcess1022KtoRenameError = undefined
        })
        builder.addCase(loadUserParamsProcess1022KtoRename.fulfilled, (state, action) => {
            state.loadUserParamsProcess1022KtoRenameStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1022KtoRename.rejected, (state, action) => {
            state.loadUserParamsProcess1022KtoRenameStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1022KtoRenameError = action.error.message
            } else {
                state.loadUserParamsProcess1022KtoRenameError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1022KtoRename,
    resetstartProcess1022KtoRenameError,
    resetloadUserParamsProcess1022KtoRename,
    resetloadUserParamsProcess1022KtoRenameError,
    removeFromProcess1022KtoRenameListById,
    removeFromProcess1022KtoRenameListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1022KtoRenameSlice.actions
export default Process1022KtoRenameSlice.reducer
